import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Select, Grid, MenuItem } from "@mui/material";
import React from "react";
import { RiFullscreenExitFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";

const Sellers = ({
  data = [],
  page = 1,
  rowsPerPage = 10,
  pagination,
  onPreviousPage,
  onNextPage,
  onRowsPerPageChange,
  isSearching = false,
}) => {
  const totalItems = isSearching ? data?.length : pagination?.totalItems || data?.length || 0;
  const currentPage = isSearching ? 1 : pagination?.currentPage || page;
  const totalPages = isSearching ? 1 : pagination?.totalPages || 1;
  const startRow = totalItems === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const endRow = totalItems === 0 ? 0 : startRow + data?.length - 1;
  const rowsText = `${startRow}-${endRow} of ${totalItems}`;

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <TableContainer>
          <Table>
            <TableHead sx={{ bgcolor: "#f8f8f7" }}>
              <TableRow>
                <TableCell sx={{ color: "#101010", fontWeight: 500 }}>User ID</TableCell>
                <TableCell sx={{ color: "#101010", fontWeight: 500 }}>Name</TableCell>
                <TableCell sx={{ color: "#101010", fontWeight: 500 }}>Email Address</TableCell>
                <TableCell sx={{ color: "#101010", fontWeight: 500 }}>Location</TableCell>
                <TableCell sx={{ color: "#101010", fontWeight: 500 }}>Profile</TableCell>
                <TableCell align="center" sx={{ color: "#101010", fontWeight: 500 }}>Status</TableCell>
                <TableCell align="center" sx={{ color: "#101010", fontWeight: 500 }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ fontSize: "12px" }}>{item._id}</TableCell>
                  <TableCell sx={{ fontSize: "12px" }}>{`${item?.firstName} ${item?.lastName}`}</TableCell>
                  <TableCell sx={{ fontSize: "12px" }}>{item.email}</TableCell>
                  <TableCell sx={{ fontSize: "12px" }}>{`${item?.addresses?.[0]?.city?.state?.country?.name || "--"}`}</TableCell>
                  <TableCell sx={{ fontSize: "12px" }}>Seller</TableCell>
                  <TableCell align="right">
                    <Box
                      sx={{
                        bgcolor: item?.activityStatus === "ACTIVE" ? "#ECF8F0" : "#FFE5E8",
                        px: 3,
                        py: 1,
                        borderRadius: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          color: item?.activityStatus === "ACTIVE" ? "#3FB763" : "#FF3347",
                          textAlign: "center",
                          fontSize: "10px",
                          fontWeight: 500,
                        }}
                      >
                        {item?.activityStatus}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <Link to={`/dashboard/user-details/${item?._id}`}>
                      <IconButton>
                        <RiFullscreenExitFill style={{ fontSize: "12px" }} />
                      </IconButton>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid container sx={{ bgcolor: "#fff", mt: 3, px: 4, py: 1 }}>
          <Grid item lg={4} md={4} xs={4} sx={{ display: "flex", alignItems: "center" }}>
            <Typography sx={{ color: "#424242", fontSize: "13px", fontFamily: "Lato" }}>
              {rowsText}
            </Typography>
          </Grid>
          <Grid item lg={8} md={8} xs={8}>
            <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
              <Typography
                sx={{
                  color: "#424242",
                  fontSize: "13px",
                  fontFamily: "Lato",
                  display: { lg: "block", xs: "none" },
                }}
              >
                You are currently on Page {currentPage}
              </Typography>
              <Select
                size="small"
                sx={{ fontFamily: "Lato", color: "#424242", fontSize: "13px" }}
                value={rowsPerPage}
                onChange={onRowsPerPageChange}
              >
                <MenuItem sx={{ fontFamily: "Lato", color: "#424242" }} value={5}>5</MenuItem>
                <MenuItem sx={{ fontFamily: "Lato", color: "#424242" }} value={10}>10</MenuItem>
                <MenuItem sx={{ fontFamily: "Lato", color: "#424242" }} value={25}>25</MenuItem>
                <MenuItem sx={{ fontFamily: "Lato", color: "#424242" }} value={50}>50</MenuItem>
              </Select>
              <Box sx={{ borderLeft: "1px solid #424242", pl: { md: 4, xs: 2 }, ml: { md: 3, xs: 2 } }}>
                <IconButton
                  disabled={isSearching || currentPage <= 1}
                  onClick={onPreviousPage}
                  sx={{ width: "30px", height: "30px", border: "1px solid #424242", "&.Mui-disabled": { border: "1px solid #4242421a" } }}
                >
                  <ChevronLeftRoundedIcon />
                </IconButton>
                <IconButton
                  disabled={isSearching || currentPage >= totalPages}
                  onClick={onNextPage}
                  sx={{ ml: 4, width: "30px", height: "30px", border: "1px solid #424242", "&.Mui-disabled": { border: "1px solid #4242421a" } }}
                >
                  <ChevronRightRoundedIcon />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Sellers;
